import { IGenericResponse } from '../../../interfaces/shared.interface';
import { apiRQ } from '../../api';
import { useMutation } from 'react-query';
import { getHttpMethod } from '../../helpers';

const updateCreateType = async (variables: any): Promise<IGenericResponse> => {
  const resp = await apiRQ[getHttpMethod(variables?.id)]<IGenericResponse>('/admin/expense-type/', variables);

  return resp.data;
};

export const useUpdateCreateType = () => {
  return useMutation<IGenericResponse, Error>(updateCreateType);
};

const deleteType = async (data: any): Promise<IGenericResponse> => {
  const resp = await apiRQ.delete<IGenericResponse>('/admin/expense-type/', { data });

  return resp.data;
};

export const useDeleteType = () => {
  return useMutation<IGenericResponse, Error>(deleteType);
};
